import React from "react";
import { Button } from "@material-ui/core";

import LoadingButton from "components/LoadingButton";
import { ControlsContainer, ControlContainer } from "./styles";
import SubmitButtonControl, {
  CancelButtonControl,
} from "components/FormControl/SubmitButtonControl";

interface Props {
  isEditMode: boolean;
  isNew?: boolean;
  onCancelClick?: (cb: any) => void;
  onEditClick?: () => void;
  isLoading: boolean;
}

const Controls = ({
  isEditMode,
  isNew,
  onCancelClick = () => {},
  onEditClick = () => {},
  isLoading = false,
}: Props) => {
  return (
    <ControlsContainer>
      {isEditMode ? (
        <>
          <ControlContainer>
            <CancelButtonControl
              render={({ onClick }: any) => (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={onClick}
                  fullWidth
                >
                  Cancel
                </Button>
              )}
              onClick={onCancelClick}
            />
          </ControlContainer>
          <ControlContainer>
            <SubmitButtonControl
              render={({ onClick }: any) => {
                return (
                  <LoadingButton
                    onClick={onClick}
                    variant="contained"
                    color="primary"
                    isLoading={isLoading}
                    fullWidth
                  >
                    {isNew ? "Add" : "Save"}
                  </LoadingButton>
                );
              }}
            />
          </ControlContainer>
        </>
      ) : (
        <ControlContainer>
          <Button
            variant="outlined"
            color="primary"
            onClick={onEditClick}
            fullWidth
          >
            Edit
          </Button>
        </ControlContainer>
      )}
    </ControlsContainer>
  );
};

export default Controls;
